// Constantes compartilhadas (status, tipos de documento, áreas, UFs, modalidades).
// Extraído em 2026-05-23 (frontend wave 3B).

// 02/10/2026: os status viraram as etapas do pipeline de licitações
// (pipeline/etapas.ts é o espelho oficial). `em_proposta` é legado e vale
// como Proposta. Triagem = novo · em_analise · descartado.
export const STATUS_INTERNO_CFG: Record<string, { label: string; tagColor: string }> = {
  novo:                 { label: 'Novo',                   tagColor: 'gold' },
  em_analise:           { label: 'Em análise',             tagColor: 'blue' },
  avaliando:            { label: 'Avaliando',              tagColor: 'cyan' },
  preparacao:           { label: 'Preparação',             tagColor: 'geekblue' },
  proposta:             { label: 'Proposta',               tagColor: 'purple' },
  em_proposta:          { label: 'Proposta',               tagColor: 'purple' },
  sessao:               { label: 'Sessão',                 tagColor: 'blue' },
  habilitacao_recursos: { label: 'Habilitação e recursos', tagColor: 'orange' },
  homologacao:          { label: 'Homologação',            tagColor: 'lime' },
  ganho:                { label: 'Contrato assinado',      tagColor: 'green' },
  perdido:              { label: 'Perdido',                tagColor: 'red' },
  nao_participamos:     { label: 'Não participamos',       tagColor: 'default' },
  descartado:           { label: 'Descartado',             tagColor: 'default' },
};
export const STATUS_TRIAGEM = ['novo', 'em_analise', 'descartado'];

export const TIPOS_DOC = [
  { id: 'atestado_tecnico',   label: 'Atestado técnico' },
  { id: 'cat',                label: 'CAT (Acervo Técnico)' },
  { id: 'cnd',                label: 'CND (Certidão Negativa)' },
  { id: 'balanco',            label: 'Balanço patrimonial' },
  { id: 'indice_financeiro',  label: 'Índice financeiro' },
  { id: 'certidao',           label: 'Certidão (geral)' },
  { id: 'outro',              label: 'Outro' },
];

export const AREAS_TECNICAS = ['Topografia', 'Hidrometria', 'Hidrologia', 'Hidráulica', 'Outros'];

export const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
  'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

export const MODALIDADES_PADRAO = [
  { id: 6, label: 'Pregão Eletrônico', dest: true },
  { id: 4, label: 'Concorrência Eletrônica', dest: true },
  { id: 5, label: 'Concorrência Presencial' },
  { id: 8, label: 'Dispensa de Licitação' },
  { id: 7, label: 'Pregão Presencial' },
  { id: 9, label: 'Inexigibilidade' },
  { id: 12, label: 'Credenciamento' },
  { id: 11, label: 'Pré-qualificação' },
  { id: 2, label: 'Diálogo Competitivo' },
  { id: 3, label: 'Concurso' },
];
